import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute, buildRoute } from 'appRoutes'

export const Route = createFileRoute('/_authenticated/workspaces/$subscriptionId/templates/$')({
  beforeLoad: ({ params }) => {
    if (!params._splat) {
      throw redirect({
        to: buildRoute(AppRoute.RulesetsListing, { subscriptionId: params.subscriptionId }),
        replace: true,
      })
    }

    throw redirect({
      to: buildRoute(AppRoute.TemplateRoute, {
        subscriptionId: params.subscriptionId,
        templateSlug: params._splat,
      }),
      replace: true,
    })
  },
})
